export type StatsigEnvironmentTier = "development" | "staging" | "production";

export const toStatsigEnvironmentTier = (
  environment?: string | null
): StatsigEnvironmentTier => {
  switch (environment?.trim().toLowerCase()) {
    case "develop":
    case "development":
    case "localhost":
      return "development";
    case "stage":
    case "staging":
      return "staging";
    default:
      return "production";
  }
};
